import React, { useState, useEffect, useCallback } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Header from '../../components/headerbar/Header'
import { useParams, useNavigate } from 'react-router-dom'
import {config} from '../../config'
import axios from 'axios'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import Sidebar from '../../components/sidebar/Sidebar'
import moment from 'moment'
import _ from 'lodash'

const ViewCustomRequest = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const navigate = useNavigate()
  const params = useParams()

  const [details, setDetails] = useState('')

  // Get custom request by id
  const getCustomRequest = useCallback(async () => {
    let res = await fetch(config.apiurl + '/customreq/' + params.id, {
      method: 'get',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    res = await res.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setDetails(res?.data)
  }, [accesstoken.data.access_token, params.id])
  useEffect(() => {
    getCustomRequest()
  }, [getCustomRequest])

  console.log('hhhhhhh', details)

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-md-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Custom Request View</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-12 col-sm-12 mb-xl-0 mb-8">
                    <div className="">
                      <div className="card-body p-3">
                        <div className="row">
                          <div className="numbers">
                            <p
                              className="text-sm mb-0 text-uppercase font-weight-bold"
                              style={{
                                margin: '20px 30px 20px 30px',
                                color: 'black',
                                fontSize: '30px',
                              }}
                            >
                              Request Details
                            </p>
                            <div className="table-responsive p-5">
                              <Card style={{ width: '80%' }}>
                                <ListGroup variant="flush">
                                  <ListGroup.Item>
                                    Name : {details?.name}
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    Phone No : {details?.mobilenum}
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    Email : {details?.email}
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    Requested metal type :{' '}
                                    {details?.category_id?.name}
                                  </ListGroup.Item>{' '}
                                  <ListGroup.Item>
                                    Requested date :{' '}
                                    {moment(details?.createdAt).format(
                                      'DD-MM-YYYY'
                                    )}
                                  </ListGroup.Item>{' '}
                                  <ListGroup.Item>
                                    Message : {details?.message}
                                  </ListGroup.Item>
                                </ListGroup>
                              </Card>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                gap: 20,
                                flexWrap: 'wrap',
                              }}
                            >
                              {details?.image?.map((data) => (
                                <img
                                  src={config.fileurl + data}
                                  alt="img"
                                  width={240}
                                  height={240}
                                />
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <ToastContainer /></main>
    </>
  )
}

export default ViewCustomRequest
